export default function () {
    const config = useRuntimeConfig()

    return {
        provider: `${config.public.baseUrl}/shop/login/index.html`
    }
}